export class EditProjectContactPersonDto {
    structurePath: string;
    userId = 0;
}
